import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';

import { CheckKeys } from '@config/keys/check.keys';
import { DoodOpenCheck } from '@core/models/check.model';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-check-card',
  templateUrl: './check-card.component.html',
})
export class CheckCardComponent {
  @Input() check!: DoodOpenCheck;

  checkKeys = CheckKeys;

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  goToCheckDetails(id: string): void {
    this.analyticsService.log({
      level: 'debug',
      label: '#DOOD-1250 Navigate',
      message: {
        from: 'CheckCardComponent Ligne°24',
        target: [this.routerHelper.translateRoute(`/checks/${id}/details`)],
        currentLocation: window.location.pathname,
      },
    });
    this.router.navigate([this.routerHelper.translateRoute(`/checks/${id}/details`)]);
  }
}
